import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource-variable/inter/wght.css";
import "@fontsource-variable/jetbrains-mono/wght.css";
import "./styles/tokens.css";
import "./styles/global.css";
import { App } from "./app/App";
import { SetupRequiredScreen } from "./app/SetupRequiredScreen";
import { getWebEnv } from "./lib/env";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found");
}

const env = getWebEnv();

createRoot(rootElement).render(
  <StrictMode>{env ? <App env={env} /> : <SetupRequiredScreen />}</StrictMode>
);
